import { ComponentChildren, h } from "preact";
import { IconSvg } from "uitoolkit";
import "./tree.scss";

// todo: consider if the area to the left of the chevron should also count as a chevron-click

export function Tree(props: { class?: string, children: ComponentChildren }) {
    return (
        <div className={props.class ? ("component4-tree " + props.class) : "component4-tree"}>
            {
                props.children
            }
        </div>
    );
}

export function TreeItem(props: {
    id?: string,
    label: string,
    chevron?: string,
    icon?: string,
    children?: ComponentChildren,
    class?: string,
    onChevronClicked?: (id: string | undefined) => void,
    onItemClicked?: (id: string | undefined) => void
}) {
    return (
        <div className={"component4-treeitem" + (props.class ? ` ${props.class}` : "")} onClick={!props.onItemClicked ? undefined : () => props.onItemClicked?.(props.id)}>
            <div>
                {
                    props.chevron && <span class="chevron" onClick={!props.onChevronClicked ? undefined : (e) => { e.stopPropagation(); props.onChevronClicked?.(props.id); }}>{
                        IconSvg(props.chevron)
                    }</span>
                }
                {
                    props.icon && <span>{IconSvg(props.icon)}</span>
                }
                {
                    props.label &&
                    <span class="label">{props.label}</span>
                }
            </div>
            {
                props.children &&
                <div>
                    {
                        props.children
                    }
                </div>
            }
        </div>
    );
}
